import React from 'react'

import Header from 'app/InspirationPage/components/revamp/Header'
import PageHeader from 'app/InspirationPage/components/revamp/PageHeader'
import InspirationBlock from '../components/revamp/InspirationBlock'

import type { FC } from 'react'

interface InspirationRevampProps {}

const InspirationRevamp: FC<InspirationRevampProps> = () => {
  return (
    <div>
      <PageHeader />
      <div className="min-h-full w-full absolute h-full overflow-y-scroll overflow-x-hidden pb-14 mt-14">
        <Header />
        <InspirationBlock includeBuktiKarya={false} />
      </div>
    </div>
  )
}
export default InspirationRevamp
